import React from "react";
import useMobileBreakpoint from "@arctheme-hooks/useMobileBreakpoint";

import './Expertise.scss';
import Carousel from "./layouts/Carousel";
import Grid from "./layouts/Grid";

const layouts = {
  'grid': Grid,
  'carousel': Carousel,
}

export const Expertise = ({
  settings,
  blocks 
}) => {
  const isMobile = useMobileBreakpoint(settings.mobile_breakpoint);
  const layout = isMobile ?settings?.section.layout_mobile : settings?.section.layout;

  const LayoutComponent = layouts[layout] || Grid;
  return (
    <>
      <LayoutComponent
          settings={settings}
          blocks={blocks}
      />
    </>
  );
};

export default Expertise;